import { Box, Typography } from "@mui/material";

export default function ScannedBilletInfo({ billet }) {
    return (
        <Box sx={{display: 'flex', flexDirection: 'column', alignItems: 'center', padding: 2}}>
            <Typography variant="subtitle1" textTransform='capitalize'>{billet.owner.prenom+' '+billet.owner.nom}</Typography>
            <Typography variant="body1">{billet.tarif} - {billet.price?.toFixed(2)} €</Typography>

            <Typography variant="h6" mt={2}>Statut : <span style={{textTransform: 'capitalize', color: ['validé', 'valide'].includes(billet.statut) ? 'green' : 'red'}}>{billet.statut==='validé' ? 'scanné' : billet.statut}</span></Typography>
        </Box>
    );
}
